/*
 * Jellice free-gift v2
 * - Auto-adds the High Absorption Mask pack when the qualifying (non-gift)
 *   subtotal reaches $50; removes it when it drops below; caps qty at 1.
 * - Brand-styled progress message in cart drawer + cart page.
 * - Makes add-to-cart open the cart DRAWER site-wide (intercepts plain
 *   /cart/add form posts) and wires the header cart icon to the drawer,
 *   with safe fallbacks if the theme's own drawer JS failed to bind.
 * The 100%-off itself comes from the automatic discount
 * "Free High Absorption Mask on orders $50+".
 */
(function () {
  var GIFT_VARIANT_ID = 49188459479359;
  var GIFT_PRODUCT_ID = 9555372671295;
  var THRESHOLD = 5000; // cents ($50.00)
  var GIFT_NAME = 'High Absorption Mask pack';
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var syncing = false;
  var queued = false;

  /* ---------- styles (brand: lavender #c8afd1, deep purple #4d425a) ---------- */
  function ensureStyles() {
    if (document.getElementById('jfg-style')) return;
    var s = document.createElement('style');
    s.id = 'jfg-style';
    s.textContent =
      '.jfg-msg{margin:4px 0 22px;padding:13px 18px;border-radius:4px;background:rgba(200,175,209,.16);border:1px solid rgba(200,175,209,.55);color:#4d425a;font-family:var(--font-body-family,sans-serif);font-size:14px;line-height:1.5;text-align:center;letter-spacing:.02em}' +
      '.jfg-msg strong{font-weight:700}' +
      '.jfg-msg__bar{height:5px;border-radius:5px;background:rgba(77,66,90,.14);margin-top:9px;overflow:hidden}' +
      '.jfg-msg__fill{height:100%;border-radius:5px;background:#c8afd1;transition:width .35s ease}' +
      '.jfg-msg--unlocked .jfg-msg__fill{background:#4d425a}' +
      '#CartDrawer .jfg-msg{margin:10px 16px 4px;font-size:13px;padding:11px 14px}' +
      '@media(max-width:600px){.jfg-msg{font-size:13px;padding:11px 14px}}';
    document.head.appendChild(s);
  }

  /* ---------- drawer helpers (independent of theme JS having bound) ---------- */
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    d.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    return true;
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
  function wireDrawer() {
    var d = drawerEl();
    if (!d) return;
    // Heal inline onclick="this.closest('cart-drawer').close()" if the
    // theme's custom element constructor failed to attach methods.
    if (typeof d.close !== 'function') d.close = closeDrawer;
    if (typeof d.open !== 'function') d.open = function () { openDrawer(); };
    var ov = document.getElementById('CartDrawer-Overlay');
    if (ov && !ov.dataset.jfgWired) { ov.dataset.jfgWired = '1'; ov.addEventListener('click', closeDrawer); }
    // Header cart icon -> open drawer instead of /cart page.
    var links = document.querySelectorAll('#cart-icon-bubble, header a[href*="/cart"], .header a[href*="/cart"], .header__icons a[href*="/cart"]');
    links.forEach(function (a) {
      if (a.dataset.jfgWired) return;
      a.dataset.jfgWired = '1';
      a.addEventListener('click', function (e) {
        if (!drawerEl()) return; // no drawer -> normal link
        e.preventDefault();
        openDrawer();
      });
    });
  }

  /* ---------- cart api ---------- */
  function getCart() {
    return fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function qualifyingTotal(cart) {
    return cart.items.reduce(function (sum, it) {
      if (it.product_id === GIFT_PRODUCT_ID) return sum;
      return sum + (it.original_line_price != null ? it.original_line_price : it.line_price);
    }, 0);
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.id === GIFT_VARIANT_ID || it.variant_id === GIFT_VARIANT_ID || it.product_id === GIFT_PRODUCT_ID) return it;
    }
    return null;
  }
  function sectionsToRender() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    if (document.getElementById('main-cart-items')) ids.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) ids.push('main-cart-footer');
    return ids.join(',');
  }
  function innerHTMLFrom(html, selector) {
    try { var d = new DOMParser().parseFromString(html, 'text/html'); var el = d.querySelector(selector); return el ? el.innerHTML : null; } catch (e) { return null; }
  }
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var cd = document.getElementById('CartDrawer');
      if (cd) { var h = innerHTMLFrom(sections['cart-drawer'], '#CartDrawer'); if (h != null) cd.innerHTML = h; }
      var d = drawerEl();
      if (d && sections['cart-drawer'].indexOf('is-empty') === -1) d.classList.remove('is-empty');
    }
    if (sections['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      if (b) { var hb = innerHTMLFrom(sections['cart-icon-bubble'], '.shopify-section'); if (hb != null) b.innerHTML = hb; }
    }
    if (sections['main-cart-items']) {
      var mi = document.getElementById('main-cart-items');
      if (mi) {
        var target = mi.querySelector('.js-contents');
        var hm = innerHTMLFrom(sections['main-cart-items'], '.js-contents');
        if (hm != null && target) target.innerHTML = hm; else if (hm != null) mi.innerHTML = hm;
      }
    }
    if (sections['main-cart-footer']) {
      var mf = document.getElementById('main-cart-footer');
      if (mf) { var hf = innerHTMLFrom(sections['main-cart-footer'], '.js-contents'); if (hf != null && mf.querySelector('.js-contents')) mf.querySelector('.js-contents').innerHTML = hf; }
    }
    wireDrawer(); // overlay was replaced -> rebind
  }
  function post(url, body) {
    body.sections = sectionsToRender();
    body.sections_url = window.location.pathname;
    return fetch(rootUrl + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function addGift() { return post('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }); }
  function setGiftQty(qty, key) { return post('cart/change.js', { id: key || String(GIFT_VARIANT_ID), quantity: qty }); }

  /* ---------- progress message ---------- */
  function renderMessage(cart) {
    ensureStyles();
    document.querySelectorAll('.jfg-msg').forEach(function (n) { n.remove(); });
    if (!cart || cart.item_count === 0) return;
    var qt = qualifyingTotal(cart);
    var unlocked = qt >= THRESHOLD;
    var pct = Math.min(100, Math.round((qt / THRESHOLD) * 100));
    var text = unlocked
      ? '🎁 You’ve unlocked a <strong>FREE ' + GIFT_NAME + '</strong> — added to your cart.'
      : 'You’re <strong>$' + ((THRESHOLD - qt) / 100).toFixed(2) + '</strong> away from a <strong>FREE ' + GIFT_NAME + '</strong>.';
    var card = document.createElement('div');
    card.className = 'jfg-msg' + (unlocked ? ' jfg-msg--unlocked' : '');
    card.innerHTML = '<div>' + text + '</div><div class="jfg-msg__bar"><div class="jfg-msg__fill" style="width:' + pct + '%"></div></div>';
    // Cart drawer: after the drawer header if present.
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (inner) {
      var head = inner.querySelector('.drawer__header');
      if (head && head.nextSibling) inner.insertBefore(card.cloneNode(true), head.nextSibling);
      else inner.insertBefore(card.cloneNode(true), inner.firstChild);
    }
    // Cart page: above the items list.
    var mi = document.getElementById('main-cart-items');
    if (mi) {
      var jc = mi.querySelector('.js-contents');
      mi.insertBefore(card, jc || mi.firstChild);
    }
  }

  /* ---------- gift sync ---------- */
  function sync() {
    if (syncing) { queued = true; return Promise.resolve(); }
    syncing = true;
    return getCart().then(function (cart) {
      var qt = qualifyingTotal(cart);
      var g = giftLine(cart);
      if (qt >= THRESHOLD && !g) {
        return addGift().then(function (res) { applySections(res.sections); });
      } else if (qt < THRESHOLD && g) {
        return setGiftQty(0, g.key).then(function (res) { applySections(res.sections); });
      } else if (g && g.quantity > 1) {
        return setGiftQty(1, g.key).then(function (res) { applySections(res.sections); });
      }
      return null;
    }).then(function () { return getCart(); })
      .then(function (cart) { renderMessage(cart); })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (queued) { queued = false; return sync(); }
      });
  }

  /* ---------- intercept ALL add-to-cart forms -> AJAX + open drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!drawerEl()) return; // no drawer on page -> keep native behavior
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    fd.append('sections', sectionsToRender());
    fd.append('sections_url', window.location.pathname);
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok || res.body.status) {
          alert(res.body.description || res.body.message || 'Could not add to cart.');
          return;
        }
        applySections(res.body.sections);
        openDrawer();
        setTimeout(sync, 60); // gift check after the user's add
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit(); // network problem -> native fallback
      });
  }, true);

  /* ---------- react to the theme's own cart mutations ---------- */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) ? arguments[0].url : ('' + arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (!syncing && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(sync, 80); }).catch(function () {});
      }
      return p;
    };
  }

  function init() { ensureStyles(); wireDrawer(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
